import { createApiSlice } from "@common";
import { CRUD_COMPANY_SIZE } from "@routes";

const apiConfig = [
  {
    name: "addCompanySize",
    method: "post",
    url: CRUD_COMPANY_SIZE,
    stateKey: "message"
  },
  {
    name: "getCompanySize",
    method: "get",
    url: CRUD_COMPANY_SIZE,
    stateKey: "data"
  },
  {
    name: "updateCompanySize",
    method: "put",
    url: CRUD_COMPANY_SIZE,
    stateKey: "message"
  },
  {
    name: "deleteCompanySize",
    method: "delete",
    url: CRUD_COMPANY_SIZE,
    stateKey: "message"
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: []
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "companySize",
  apiConfig,
  customReducers
);
const companySizeSlice = slice;

export default companySizeSlice.reducer;

export const {
  addCompanySize,
  getCompanySize,
  updateCompanySize,
  deleteCompanySize
} = thunks;
export const { rowSelect } = actions;
